import hourglassIcon from "@/assets/hourglass-logo.webp";

const PageLoader = () => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-background z-50">
      <div className="animate-spin">
        <img src={hourglassIcon} alt="Loading" className="h-14 w-14 object-contain" />
      </div>
    </div>
  );
};

export default PageLoader;
